export default ['#4bbcad',
  '#d54539',
  '#5ab94d',
  '#8a5cd3',
  '#a4b243',
  '#ba5ccd',
  '#54995c',
  '#cf47a1',
  '#d29f3e',
  '#5c6fda',
  '#c36528',
  '#5fa6dc',
  '#d74770',
  '#7d7430',
  '#8a529e',
  '#df9273',
  '#5f74b8',
  '#ac5450',
  '#d192d7',
  '#b26088'];
